var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 11C10.567 11 9 12.567 9 14.5L9 42.5C9 44.433 10.567 46 12.5 46H41C42.933 46 44.5 44.433 44.5 42.5V18.7857L42.3448 20.8383L41.6552 20.1141L45 16.9286L48.3448 20.1141L47.6552 20.8383L45.5 18.7857V42.5C45.5 44.9853 43.4853 47 41 47H12.5C10.0147 47 8 44.9853 8 42.5L8 14.5C8 12.0147 10.0147 10 12.5 10L29 10V11L12.5 11ZM23.5232 37.8494L29.5232 18.8494L30.4768 19.1506L24.4768 38.1506L23.5232 37.8494ZM14.3536 27.9393L20.6464 21.6464L21.3536 22.3536L15.0607 28.6465C14.8654 28.8417 14.8654 29.1583 15.0607 29.3536L21.3536 35.6464L20.6464 36.3536L14.3536 30.0607C13.7678 29.4749 13.7678 28.5251 14.3536 27.9393ZM38.9393 28.6465L32.6464 22.3536L33.3536 21.6464L39.6464 27.9393C40.2322 28.5251 40.2322 29.4749 39.6464 30.0607L33.3536 36.3536L32.6464 35.6464L38.9393 29.3536C39.1346 29.1583 39.1346 28.8417 38.9393 28.6465Z",
    fill: "#2C666E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.eb54f48a49538ce78df281212b8f2129.svg";
export { ForwardRef as ReactComponent };